/**
 * Converts a camelCase string to snake_case
 * @param {string} str - The camelCase string to convert
 * @returns {string} The snake_case string
 */
export const camelToSnakeCase = (str) => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

/**
 * Converts a snake_case string to camelCase
 * @param {string} str - The snake_case string to convert
 * @returns {string} The camelCase string
 */
export const snakeToCamelCase = (str) =>
    str.toLowerCase().replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());

/**
 * Recursively converts all keys in an object from camelCase to snake_case
 * @param {Object|Array} obj - The object to convert
 * @returns {Object|Array} A new object with all keys converted to snake_case
 */
export const convertKeysToSnakeCase = (obj) => {
    if (Array.isArray(obj)) {
        return obj.map(item => convertKeysToSnakeCase(item));
    }

    if (obj !== null && typeof obj === 'object') {
        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [
                camelToSnakeCase(key),
                convertKeysToSnakeCase(value)
            ])
        );
    }

    return obj;
};

/**
 * Recursively converts all keys in an object from snake_case to camelCase
 * @param {Object|Array} obj - The object to convert
 * @returns {Object|Array} A new object with all keys converted to camelCase
 */
export const convertKeysToCamelCase = (obj) => {
    if (Array.isArray(obj)) {
        return obj.map(item => convertKeysToCamelCase(item));
    }

    if (obj !== null && typeof obj === 'object') {
        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [
                snakeToCamelCase(key),
                convertKeysToCamelCase(value)
            ])
        );
    }

    return obj;
}; 